// extracted by mini-css-extract-plugin
export var container = "_5h-0";
export var fallback = "_5h-5";
export var fallbackIcon = "_5h-6";
export var hidden = "_5h-2";
export var image = "_5h-3";
export var loaded = "_5h-4";
export var placeholder = "_5h-1";